import React, { useEffect, useState } from 'react';
import IframeComponent from '../../components/IframeComponent';
import LoadingPage from '../../components/LoadingPage';
import { withLinkValidation } from '../../hoc/withLinkValidation';

const TicketIframe = ({ params }) => {
    const [paymentUrl, setPaymentUrl] = useState('');
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        let environment = "prod";

        const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('/qa/')) {
            environment = "qa"
        }

        // Get parameters from props (passed by HOC)
        const ticketId = params.get('ticketId');
        const commandId = params.get('commandId');
        const customerId = params.get('customerId');
        const email = params.get('email');
        let amount = (params.get('amount') * 100).toString();
        
        const userDataArray = [
            { key: 'ticketId', value: ticketId },
            { key: 'commandId', value: commandId },
            { key: 'customerId', value: customerId },
        ];

        // Constructing userData XML elements
        let userDataXml = userDataArray
            .map((data, index) => `<userData${index + 1}>${data.value}</userData${index + 1}>`)
            .join('');

        userDataXml += `<userData9>${environment}</userData9>`;
        userDataXml += `<userData10>ticket</userData10>`;

        const fetchPayment = async () => {
            try {
                const response = await fetch(`${backendUrl}/api/qa/get-payment-page`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 
                        amount: amount,
                        ...email && { email },
                        customerId: customerId,
                        env: environment,
                        userData: userDataXml
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                setPaymentUrl(data.url);
            } catch (error) {
                console.log("Something happened: ", error);
            }
        };

        fetchPayment();
    }, [params, backendUrl]);

    return (
        <>
            {paymentUrl ? (
                <IframeComponent src={paymentUrl}/>
            ) : (
                <LoadingPage/>
            )}
        </>
    );
};

export default withLinkValidation(TicketIframe);
